<!-- FLAG -->
<a [attr.data-btnId]="getElementId('toggleFlag')" (click)="toggleFlag()" ngbTooltip="{{ 'Add a visual indicator flag to the map element' | translate }}">
    <fa-icon [icon]="[ flag ? 'fas' : 'far', 'flag' ]"></fa-icon>
</a>
